var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6697 6.39485C21.1559 6.15098 20.5622 6.21766 20.1187 6.56992L17.6163 8.55384V8.12903C17.6163 5.78903 16.3153 4.5 13.9535 4.5H5.16279C2.80102 4.5 1.5 5.78903 1.5 8.12903V15.871C1.5 18.211 2.80102 19.5 5.16279 19.5H13.9535C16.3153 19.5 17.6163 18.211 17.6163 15.871V15.4462L20.1197 17.431C20.3853 17.642 20.7068 17.7502 21.032 17.7502C21.2479 17.7502 21.4646 17.7029 21.6697 17.6052C22.1805 17.3613 22.5 16.859 22.5 16.2967V7.70423C22.5 7.141 22.1815 6.63968 21.6697 6.39485ZM16.1512 15.871C16.1512 17.3971 15.4938 18.0484 13.9535 18.0484H5.16279C3.62247 18.0484 2.96512 17.3971 2.96512 15.871V8.12903C2.96512 6.6029 3.62247 5.95161 5.16279 5.95161H13.9535C15.4938 5.95161 16.1512 6.6029 16.1512 8.12903V15.871ZM21.0349 16.2967L17.6163 13.587V10.414L21.0349 7.70423V16.2967Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f44adcc6bc847104d8e8406fd1dee82d.svg";
export { ForwardRef as ReactComponent };